import React, { useState, useEffect, useRef } from "react";
import mercedesV250Image from "../../images/slide-7.jpg";
import city2city from "../../images/service-img-1.jpg";
import CH from "../../images/CH.jpg";
import airportTransfer from "../../images/airportTranfer.jpg";
import hourlyHire from "../../images/hourlyHire.jpeg";
import Carousel from "../../components/carousel/Carousel";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import MobileBanner from "../../images/mobile-banner.png";
import "./landingPage.css";
import { Autocomplete } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();
  const [pickup, setPickup] = useState("");
  const [errors, setErrors] = useState({});
  const dateInputRef = useRef(null);
  const hourlyDateInputRef = useRef(null);
  const [isSearching, setIsSearching] = useState(false);
  const [destination, setDestination] = useState("");
  const [pickupAutocomplete, setPickupAutocomplete] = useState(null);
  const [pickupHourlyAutocomplete, setPickupHourlyAutocomplete] =
    useState(null);
  const [destinationAutocomplete, setDestinationAutocomplete] = useState(null);
  const [pickupDate, setPickupDate] = useState("");
  const [pickupTime, setPickupTime] = useState("");
  const [duration, setDuration] = useState(2);
  const [distance, setDistance] = useState(null);
  const About = () => {
    return (
      <section className="about" id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <h5>ABOUT US</h5>
              <h2>Passenger Transport by Luxury Vehicles</h2>
              <p>
                Velocity Limousine offers top-tier luxury transportation
                services. Our trained chauffeurs provide comfortable and stylish
                rides in our fleet of luxurious vehicles. We are renowned for
                our professionalism and commitment to delivering exceptional
                service, making us a best in the industry.
              </p>
            </div>
            <div className="col-lg-6 col-md-12">
              <img src={mercedesV250Image} alt="About Us" />
            </div>
          </div>
        </div>
      </section>
    );
  };

  const OurFleet = () => {
    return (
      <section className="our_fleet" id="our_fleet">
        <div className="container">
          <h3>Our Fleet</h3>
          <p>
            Choose from a collection of luxury vehicles including Mercedes,
            Lexus, and Tesla for a remarkable journey in Dubai.
          </p>
          <Carousel />
        </div>
      </section>
    );
  };

  const Services = () => {
    return (
      <section className="services pt-0" id="services">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-5">
              <h3>SERVICES</h3>
              <p>
                We offer a wide range of services, including airport transfers,
                city tours, day hires, corporate transportation, and event
                <br />
                transportation. Our professional chauffeurs ensure a first-class
                experience.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="service-item">
                <img src={city2city} alt="City-to-city rides" />
                <h4>City-to-city rides</h4>
                <p>
                  Your stress-free solution for long-distance rides with
                  professional chauffeurs across the globe.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="service-item">
                <img src={CH} alt="Chauffeur hailing" />
                <h4>Chauffeur hailing</h4>
                <p>
                  Enjoy the quality of a traditional chauffeur, with the
                  convenience of riding within minutes of booking.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="service-item">
                <img src={airportTransfer} alt="Airport transfers" />
                <h4>Airport transfers</h4>
                <p>
                  With additional wait time and flight tracking in case of
                  delays, our service is optimized to make every airport
                  transfer a breeze.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="service-item">
                <img src={hourlyHire} alt="Hourly and full day hire" />
                <h4>Hourly and full day hire</h4>
                <p>
                  For by-the-hour bookings or daily chauffeur hire, choose one
                  of our tailored services for total flexibility, reliability
                  and comfort.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const WhatsAppIcon = () => {
    return (
      <a
        href="https://wa.me/971548885164?text=Hello%2C%20I%27m%20interested%20in%20your%20services.%20Could%20you%20please%20provide%20more%20information%3F"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-icon"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    );
  };
  // eslint-disable-next-line no-undef
  useEffect(() => {
    // document.body.classList.remove("dark");
    const handleScroll = () => {
      const scroll = window.scrollY; // Get the current scroll position
      const element = document.querySelector("header");
      if (element) {
        if (scroll >= 2) {
          element.classList.add("lightHeader");
          document.body.classList.add("dark");
        } else {
          document.querySelector("header").classList.remove("lightHeader");
          document.body.classList.remove("dark");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Cleanup the event listener on unmount
    };
  }, []);
  const handlePickupPlaceChanged = () => {
    if (pickupAutocomplete) {
      const place = pickupAutocomplete.getPlace();
      if (place && place.formatted_address) {
        setPickup(place.formatted_address); // Update the state with the selected place
      }
    }
  };

  const handleHourlyPickupChanged = () => {
    if (pickupHourlyAutocomplete) {
      const place = pickupHourlyAutocomplete.getPlace();
      if (place && place.formatted_address) {
        setPickup(place.formatted_address); // Update the state with the selected place
      }
    }
  };

  const handleDestinationPlaceChanged = () => {
    if (destinationAutocomplete) {
      const place = destinationAutocomplete.getPlace();
      if (place && place.formatted_address) {
        setDestination(place.formatted_address); // Update the state with the selected place
      }
    }
  };
  const options = {
    componentRestrictions: { country: "ae" }, // Restricts to UAE
  };
  const validateFields = (tripType) => {
    let newErrors = {};

    if (!pickup) newErrors.pickup = "Pickup location is required";
    if (!pickupDate) newErrors.pickupDate = "Pickup date is required";
    if (!pickupTime) newErrors.pickupTime = "Pickup time is required";

    if (tripType === "singleTrip" && !destination) {
      newErrors.destination = "Destination is required";
    }

    if (tripType === "dayHire" && !duration) {
      newErrors.duration = "Duration is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const searchClick = async (e, tripType) => {
    e.preventDefault();
    if (!validateFields(tripType)) return;
    setIsSearching(true);
    document.querySelector("header").classList.remove("lightHeader");
    document.body.classList.remove("dark");
    if (tripType === "singleTrip") {
      const directionsService = new window.google.maps.DirectionsService();
      const request = {
        origin: pickup,
        destination: destination,
        travelMode: "DRIVING",
      };
      let distanceInKm = null;
      await directionsService.route(request, (result, status) => {
        if (status === "OK") {
          const distanceInMeters = result.routes[0].legs[0].distance.value;
          distanceInKm = Math.round((distanceInMeters / 1000).toFixed(2));
          setDistance(distanceInKm);
        } else {
          alert("Failed to fetch distance. Please check the locations.");
        }
      });

      navigate(
        `/booking?pickup=${pickup}&tripType=${tripType}&destination=${destination}&distance=${distanceInKm}&pickupDate=${pickupDate}&pickupTime=${pickupTime}`
      );
    } else {
      navigate(
        `/booking?pickup=${pickup}&tripType=${tripType}&pickupDate=${pickupDate}&pickupTime=${pickupTime}&duration=${duration}`
      );
    }
  };
  return (
    <div className="App">
      <div className="wrapper">
        <img src={MobileBanner} className="banner-img" alt="Mobile Banner" />
        <Header></Header>
        <div className="container">
          <div className="row">
            <div className="col-md-12 py-3">
              <h1 className="main_banner_line">
                Chauffeur driven rides - comfort at the best prices
              </h1>
            </div>
          </div>
        </div>
        <section className="banner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left">
                {/* Optional Heading */}
                {/* <h1>Your global chauffeur service</h1> */}
              </div>
              <div className="col-md-6">
                <div className="booking-form">
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                    >
                      One Way
                    </button>
                    <button
                      className="nav-link"
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                    >
                      By the hour
                    </button>
                  </div>
                  <div className="tab-content" id="nav-tabContent">
                    {/* One Way Tab */}
                    <div
                      className="tab-pane fade show active"
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="nav-home-tab"
                      tabIndex="0"
                    >
                      <form id="bookingForm">
                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              className="remixicon-icon SelectAddress_addressIcon__QBn4K"
                              width="20"
                              height="20"
                              fill="#181a1f"
                              viewBox="0 0 24 24"
                            >
                              <path d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
                            </svg>
                          </div>
                          <div className="value_wrapper">
                            <span className="label-box">From</span>
                            {/* <input
                                className="inputElement"
                                id="pickup"
                                name="pickup"
                                placeholder="Address, airport, hotel, ..."
                                value={pickup}
                                onChange={(e) => setPickup(e.target.value)}
                                required
                              /> */}
                            <Autocomplete
                              options={options}
                              onLoad={(autocomplete) =>
                                setPickupAutocomplete(autocomplete)
                              }
                              onPlaceChanged={handlePickupPlaceChanged}
                            >
                              <input
                                className="inputElement"
                                id="pickup"
                                name="pickup"
                                placeholder="Address, airport, hotel, ..."
                                //   value={pickup}
                                //   onChange={(e) => setPickup(e.target.value)}
                                required
                              />
                            </Autocomplete>
                          </div>
                        </div>
                        {errors.pickup && (
                          <span
                            className="error-text"
                            style={{
                              color: "#cc434c",
                              padding: "4px 16px 0",
                              fontSize: "14px",
                            }}
                          >
                            {errors.pickup}
                          </span>
                        )}

                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              className="remixicon-icon SelectAddress_addressIcon__QBn4K"
                              width="20"
                              height="20"
                              fill="#181a1f"
                              viewBox="0 0 24 24"
                            >
                              <path d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
                            </svg>
                          </div>
                          <div className="value_wrapper">
                            <span className="label-box">From</span>
                            {/* <input
                                className="inputElement"
                                id="pickup"
                                name="pickup"
                                placeholder="Address, airport, hotel, ..."
                                value={pickup}
                                onChange={(e) => setPickup(e.target.value)}
                                required
                              /> */}
                            <Autocomplete
                              options={options}
                              onLoad={(autocomplete) =>
                                setDestinationAutocomplete(autocomplete)
                              }
                              onPlaceChanged={handleDestinationPlaceChanged}
                            >
                              <input
                                className="inputElement"
                                id="destination"
                                name="destination"
                                placeholder="Address, airport, hotel, ..."
                                //   value={pickup}
                                //   onChange={(e) => setPickup(e.target.value)}
                                required
                              />
                            </Autocomplete>
                          </div>
                        </div>
                        {errors.destination && (
                          <span
                            className="error-text"
                            style={{
                              color: "#cc434c",
                              padding: "4px 16px 0",
                              fontSize: "14px",
                            }}
                          >
                            {errors.destination}
                          </span>
                        )}
                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              role="img"
                              aria-label="Icon/calendar"
                              className="remixicon-icon _default_rs803_65"
                              width="20px"
                              height="20px"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zM4 9v10h16V9H4zm2 4h5v4H6v-4z"></path>
                            </svg>
                          </div>
                          <div
                            className="value_wrapper"
                            onClick={() =>
                              dateInputRef.current &&
                              dateInputRef.current.showPicker()
                            }
                          >
                            <span className="label-box">Date</span>
                            <input
                              id="pickupDateInput"
                              ref={dateInputRef}
                              className="inputElement"
                              type="date"
                              name="pickupDate"
                              value={pickupDate}
                              onChange={(e) => setPickupDate(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        {errors.pickupDate && (
                          <span
                            className="error-text"
                            style={{
                              color: "#cc434c",
                              padding: "4px 16px 0",
                              fontSize: "14px",
                            }}
                          >
                            {errors.pickupDate}
                          </span>
                        )}

                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              role="img"
                              aria-label="Icon/time"
                              className="remixicon-icon _default_rs803_65"
                              width="20px"
                              height="20px"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1-10V7h-2v7h6v-2h-4z"></path>
                            </svg>
                          </div>
                          <div className="value_wrapper">
                            <span className="label-box">Time</span>
                            <input
                              className="inputElement"
                              type="time"
                              name="pickupTime"
                              value={pickupTime}
                              onChange={(e) => setPickupTime(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        {errors.pickupTime && (
                          <span
                            className="error-text"
                            style={{
                              color: "#cc434c",
                              padding: "4px 16px 0",
                              fontSize: "14px",
                            }}
                          >
                            {errors.pickupTime}
                          </span>
                        )}
                        <div></div>
                        <small className="Timepicker_hintText">
                          Complimentary Wait Time for Chauffeur Service
                        </small>

                        <button
                          onClick={(e) => searchClick(e, "singleTrip")}
                          id="single-button-submit"
                          className="button-submit"
                        >
                          Search
                          <div
                            className="loader"
                            id="loader"
                            style={{
                              display: isSearching ? "inline-block" : "none",
                            }}
                          ></div>
                        </button>
                      </form>
                    </div>

                    {/* By the Hour Tab */}
                    <div
                      className="tab-pane fade"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="nav-profile-tab"
                      tabIndex="0"
                    >
                      <form id="hourlyBookingForm">
                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              className="remixicon-icon SelectAddress_addressIcon__QBn4K"
                              width="20"
                              height="20"
                              fill="#181a1f"
                              viewBox="0 0 24 24"
                            >
                              <path d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
                            </svg>
                          </div>
                          <div className="value_wrapper">
                            <span className="label-box">From</span>
                            <Autocomplete
                              options={options}
                              onLoad={(autocomplete) =>
                                setPickupHourlyAutocomplete(autocomplete)
                              }
                              onPlaceChanged={handleHourlyPickupChanged}
                            >
                              <input
                                className="inputElement"
                                id="pickup"
                                name="pickup"
                                placeholder="Address, airport, hotel, ..."
                                //   value={pickup}
                                //   onChange={(e) => setPickup(e.target.value)}
                                required
                              />
                            </Autocomplete>
                          </div>
                        </div>
                        {errors.pickup && (
                          <span
                            className="error-text"
                            style={{
                              color: "#cc434c",
                              padding: "4px 16px 0",
                              fontSize: "14px",
                            }}
                          >
                            {errors.pickup}
                          </span>
                        )}

                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              role="img"
                              aria-label="Icon/timer"
                              className="remixicon-icon _default_rs803_65"
                              width="20px"
                              height="20px"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm3.536 5.05L10.586 12 12 13.414l4.95-4.95-1.414-1.414z"></path>
                            </svg>
                          </div>
                          <div className="value_wrapper">
                            <span className="label-box">Duration</span>
                            <select
                              className="inputElement"
                              name="duration"
                              value={duration}
                              onChange={(e) => setDuration(e.target.value)}
                              required
                            >
                              {[...Array(23)].map((_, i) => {
                                const hour = i + 2;
                                return (
                                  <option key={hour} value={hour}>
                                    {hour} hours
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        {/* <span
                          className="error-text"
                          style={{
                            color: "#cc434c",
                            padding: "4px 16px 0",
                            fontSize: "14px",
                          }}
                        >
                          {errors.duration}
                        </span> */}

                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              role="img"
                              aria-label="Icon/calendar"
                              className="remixicon-icon _default_rs803_65"
                              width="20px"
                              height="20px"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zM4 9v10h16V9H4zm2 4h5v4H6v-4z"></path>
                            </svg>
                          </div>
                          <div
                            className="value_wrapper"
                            onClick={() =>
                              hourlyDateInputRef.current &&
                              hourlyDateInputRef.current.showPicker()
                            }
                          >
                            <span className="label-box">Date</span>
                            <input
                              className="inputElement"
                              type="date"
                              ref={hourlyDateInputRef}
                              name="pickupDate"
                              value={pickupDate}
                              onChange={(e) => setPickupDate(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        {errors.pickupDate && (
                          <span
                            className="error-text"
                            style={{
                              color: "#cc434c",
                              padding: "4px 16px 0",
                              fontSize: "14px",
                            }}
                          >
                            {errors.pickupDate}
                          </span>
                        )}
                        <div className="input-block">
                          <div className="icon_wrapper">
                            <svg
                              role="img"
                              aria-label="Icon/time"
                              className="remixicon-icon _default_rs803_65"
                              width="20px"
                              height="20px"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1-10V7h-2v7h6v-2h-4z"></path>
                            </svg>
                          </div>
                          <div className="value_wrapper">
                            <span className="label-box">Time</span>
                            <input
                              className="inputElement"
                              type="time"
                              name="pickupTime"
                              value={pickupTime}
                              onChange={(e) => setPickupTime(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        {errors.pickupTime && (
                          <span
                            className="error-text"
                            style={{
                              color: "#cc434c",
                              padding: "4px 16px 0",
                              fontSize: "14px",
                            }}
                          >
                            {errors.pickupTime}
                          </span>
                        )}
                        <div></div>
                        <button
                          onClick={(e) => searchClick(e, "hourly")}
                          id="single-button-submit"
                          className="button-submit"
                        >
                          Search
                          <div
                            className="loader"
                            id="loader"
                            style={{
                              display: isSearching ? "inline-block" : "none",
                            }}
                          ></div>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <About />
      <OurFleet />
      <Services />
      <WhatsAppIcon />
      <Footer />
    </div>
  );
};

export default LandingPage;
